import { GALLERY as FALLBACK_GALLERY, RESTAURANT, WHATSAPP_URL } from "@/lib/assets";
import { useSite, resolveImg } from "@/lib/content";

const layout = [
  "col-span-2 md:col-span-8 md:row-span-2 aspect-[4/3]",
  "col-span-2 md:col-span-4 aspect-[3/4]",
  "col-span-1 md:col-span-4 aspect-[3/4]",
  "col-span-1 md:col-span-4 aspect-[3/4]",
  "col-span-2 md:col-span-4 aspect-[3/4]",
  "col-span-1 md:col-span-6 aspect-[4/3]",
  "col-span-1 md:col-span-6 aspect-[4/3]",
  "col-span-1 md:col-span-6 aspect-[4/3]",
  "col-span-1 md:col-span-6 aspect-[4/3]",
];

const spanFor = (i) => layout[i] || (i % 3 === 0
  ? "col-span-2 md:col-span-8 aspect-[4/3]"
  : "col-span-1 md:col-span-4 aspect-[3/4]");

export default function GaleriePage() {
  const { gallery } = useSite();
  const items = (gallery && gallery.length ? gallery : FALLBACK_GALLERY.map((g) => g.src));

  return (
    <div data-testid="page-galerie" className="pt-24 sm:pt-28">
      <section className="relative overflow-hidden">
        <div
          aria-hidden="true"
          data-testid="bg-word"
          className="pointer-events-none select-none absolute inset-x-0 top-16 sm:top-20 font-serif-display italic leading-[0.85] whitespace-nowrap text-center text-[24vw] sm:text-[18vw] text-[#8A1C29]/[0.05]"
        >
          Galerie
        </div>
        <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 pt-12 sm:pt-20 pb-10 sm:pb-14">
          <div className="grid lg:grid-cols-12 gap-6 lg:gap-8 items-end">
            <div className="lg:col-span-7">
              <span className="lm-eyebrow">Galerie</span>
              <h1 className="font-serif-display text-[2.25rem] sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight mt-5 sm:mt-8 text-[#1A1A18]">
                L’atelier <em className="italic text-[#8A1C29]">gourmand</em>
                <br />
                de la maison.
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 pb-20 sm:pb-24">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-3 sm:gap-4">
          {items.map((src, i) => (
            <figure
              key={`${src}-${i}`}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden group ${spanFor(i)}`}
            >
              <img
                src={resolveImg(src)}
                alt=""
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
              />
            </figure>
          ))}
        </div>

        <div className="mt-16 sm:mt-24 text-center">
          <p className="text-[#5C544F] max-w-xl mx-auto text-[14px] sm:text-base">
            Venez découvrir la maison par vous-même — {RESTAURANT.address}.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="galerie-cta-reserver"
            className="lm-btn-primary mt-6 sm:mt-8"
          >
            Réserver via WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
}
